import { render, staticRenderFns } from "./DesignForm.vue?vue&type=template&id=20cb4b18&"
import script from "./DesignForm.vue?vue&type=script&lang=js&"
export * from "./DesignForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignForm.vue?vue&type=style&index=0&id=20cb4b18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports